module.exports = __webpack_public_path__ + "static/media/串口1.27802cad.jpg";